/**
 * Keeps the shared news snapshot fresh for whichever surface needs it.
 *
 * Mounted ONCE in App. Polls only while the news is actually visible — the
 * drawer is open OR the chart overlay is on — so a user who wants neither
 * costs zero requests. The poll only reads the server's cached snapshot; the
 * upstream fetching happens on the backend's own loop.
 */
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/state/hooks";
import { fetchNews } from "@/state/slices/newsSlice";

const POLL_MS = 60_000;

export function useNewsFeed(): void {
  const dispatch = useAppDispatch();
  const drawerOpen = useAppSelector((s) => s.ui.newsOpen);
  const showOnChart = useAppSelector((s) => s.news.showOnChart);
  const wanted = drawerOpen || showOnChart;

  useEffect(() => {
    if (!wanted) return;
    void dispatch(fetchNews());
    const id = window.setInterval(() => void dispatch(fetchNews()), POLL_MS);
    return () => window.clearInterval(id);
  }, [wanted, dispatch]);
}
